import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { motion, AnimatePresence } from 'framer-motion';

const MotionBox = motion(Box);

const CompletionOverlay = ({ message, accent, theme }) => (
  <AnimatePresence>
    {message && (
      <MotionBox
        key="completion"
        position="fixed"
        inset={0}
        zIndex={500}
        display="flex"
        alignItems="center"
        justifyContent="center"
        pointerEvents="none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.35 }}
      >
        <MotionBox
          position="absolute"
          inset={0}
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          style={{
            background: `radial-gradient(ellipse 55% 45% at 50% 42%, ${accent}38 0%, ${accent}0c 45%, transparent 72%)`,
          }}
        />
        <MotionBox
          position="relative"
          textAlign="center"
          px={8}
          initial={{ opacity: 0, y: 12, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -8, scale: 0.98 }}
          transition={{ type: 'spring', stiffness: 320, damping: 28 }}
        >
          <Text
            fontSize={{ base: 'xl', md: '2xl' }}
            fontWeight="600"
            letterSpacing="-0.5px"
            mb={2}
            style={{ color: theme.textPrimary, textShadow: `0 0 40px ${accent}66` }}
          >
            {message.title}
          </Text>
          <Text fontSize="sm" fontWeight="400" style={{ color: theme.textMuted }}>
            {message.subtitle}
          </Text>
        </MotionBox>
      </MotionBox>
    )}
  </AnimatePresence>
);

export default CompletionOverlay;
